// TODO: please use in every place with bonuses
import { makeAutoObservable } from 'mobx';
import { CampaignModelType, SingleCampaignStore } from './SingleCampaign.store';
import { Common } from 'src/AppState/Common';
import {
    BonusSourceType,
    BonusStatusType,
    BonusTypeType,
    BonusViewType,
} from 'src/api_openapi/v2/bonus-engine/schemas';
import { Amount } from 'src_common/common/amount/Amount';
import { CampaignModel } from './CampaignModel';

export class BonusModel {
    public constructor(
        private readonly common: Common,
        private readonly data: BonusViewType
    ) {
        makeAutoObservable(this);
    }

    public get id(): string {
        return this.data.bonusId;
    }

    public get status(): BonusStatusType {
        return this.data.status;
    }

    public get accountId(): number {
        return this.data.accountId;
    }

    public get bonusType(): BonusTypeType {
        return this.data.bonusType;
    }

    public get bonusSource(): BonusSourceType {
        return this.data.bonusSource;
    }

    public get totalAmmount(): Amount | null {
        if (this.data.totalAmount === null || this.data.totalAmount === undefined) {
            return null;
        }

        return new Amount(this.data.totalAmount.toString());
    }

    public get totalAmmountTime(): number | null {
        return this.data.totalAmountTime ?? null; // TODO: consider format here
    }

    public get createdAt(): string | null {
        return this.data.createdAt ?? null; // TODO: consider format here
    }

    public get expiryAt(): string {
        return this.data.expiryAt; // TODO: consider format here
    }

    public get rewardName(): string | null {
        return this.data.rewardName ?? null;
    }

    public get campaignModel(): CampaignModelType | 'loading' | null {
        if (this.data.campaignId === undefined || this.data.campaignId === null) {
            return null;
        }
        return SingleCampaignStore.get(this.common, this.data.campaignId).campaignModel;
    }

    public get campaignModelWhenReady(): CampaignModel | null {
        if (this.data.campaignId === undefined || this.data.campaignId === null) {
            return null;
        }

        const result = SingleCampaignStore.get(this.common, this.data.campaignId).campaignModel;

        if (result === 'loading' || result.status === 'error') {
            return null;
        }

        return result.body;
    }
    // -- accountId: z.number(),
    // -- bonusId: z.string(),
    // -- bonusType: BonusTypeZod,
    // -- campaignId: z.string().optional().nullable(),
    // -- totalAmount: z.number().optional().nullable(),
    // -- totalAmountTime: z.number().optional().nullable(),
    // -- createdAt: z.string().optional().nullable(),
    // -- expiryAt: z.string(),
    // -- status: BonusStatusZod,
    // -- rewardName: z.string().optional().nullable(),
    //
    //
    // bonusPlatform: BettingPlatformZod,
    // bonusSource: BonusSourceZod,
    // currentAmount: z.number().optional().nullable(),
    // currentAmountTime: z.number().optional().nullable(),
    // playthrough: z.number().optional().nullable(),
    // playthroughEligibleGames: z.array(z.string()).optional().nullable(),
    // provider: z.union([ProviderZod, z.null()]).optional(),
    // totalBet: z.number().optional().nullable(),
    // universe: z.string(),
    // usageConditions: z.array(CriteriaZod).optional(),
}
